export default function sign(theCanvas, callBack) {
    //获取canvas
    let myCanvas = theCanvas;
    //canvas边界
    let canvasRect = myCanvas.getBoundingClientRect();
    //获取2d对象
    let ctx = myCanvas.getContext("2d");
    //控制线条是否画
    let isMouseMove = false;
    //线条位置
    let lastX, lastY;
    let widthVal = 5;
    let colorVal = '#000000';
    // 是否画过是否有内容
    let isDrawed = false;
    initCanvas();
    //初始化
    function initCanvas() {
        //PC端
        let down = (event) => {
            canvasRect = myCanvas.getBoundingClientRect();
            isMouseMove = true;
            const touches = [].slice.call(event.touches);
            if (touches.length > 1) { // 多点触摸，不做处理
                return;
            }
            const target = touches[0];
            drawLine(
                target.clientX - canvasRect.left,
                target.clientY - canvasRect.top,
                false
            );
        };
        let move = (event) => {
            canvasRect = myCanvas.getBoundingClientRect();
            // 禁止滑动时跟随滚动条滚动
            event.preventDefault();
            if (isMouseMove) {
                const touches = [].slice.call(event.touches);
                if (touches.length > 1) { // 多点触摸，不做处理
                    return;
                }
                const target = touches[0];
                drawLine(
                    target.clientX - canvasRect.left,
                    target.clientY - canvasRect.top,
                    true
                );
                isDrawed = true;
            }
        };
        let up = (event) => {
            isMouseMove = false;
        };
        myCanvas.addEventListener("touchstart", down);
        myCanvas.addEventListener("touchmove", move);
        myCanvas.addEventListener("touchend", up);
    }
    //画线
    function drawLine(x, y, isT) {
        if (isT) {
            ctx.beginPath();
            ctx.lineWidth = widthVal; //设置线宽状态
            ctx.strokeStyle = colorVal; //设置线的颜色状态
            ctx.lineCap = 'round'
            ctx.lineJoin = "round";
            ctx.moveTo(lastX, lastY);
            ctx.lineTo(x, y);
            ctx.stroke();
            ctx.closePath();
        }
        // 每次移动都要更新坐标位置
        lastX = x;
        lastY = y;
    }
    //清空画图
    function clearCanvas() {
        ctx.beginPath();
        ctx.clearRect(0, 0, myCanvas.width, myCanvas.height);
        ctx.closePath(); //可加入，可不加入
        isDrawed = false;
    }
    //保存图片
    function saveImgInfo() {
        let images = myCanvas.toDataURL('image/png');
        callBack('confirm', images);
    }
    //保存图片
    function getIsDrawed() {
        return isDrawed;
    }
    return {
        clearCanvas: clearCanvas,
        saveImgInfo: saveImgInfo,
        getIsDrawed: getIsDrawed
    }
}